import styled from 'styled-components';
import DefaultModal from 'components/Modals/Modal';
import { Body, H2 } from 'components/Typography';
import DefaultButton from 'components/Buttons/Button';

export const Modal = styled(DefaultModal)`
  .modal-ui {
    width: 30rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const Title = styled(H2)`
  color: ${({ theme }) => theme.colors.navyGreen};
  margin-top: 1rem;
  font-weight: bolder;
`;

export const Text = styled(Body)`
  margin-top: 0.5rem;
  margin-bottom: 2.25rem;
`;

export const Button = styled(DefaultButton)`
  margin-top: 1rem;
`;

export const TitleRow = styled.div`
  display: flex;
  flex-direction: column;
`;
